import React from 'react'
import { Typography, Box } from '@mui/material'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/es'
import { NotificationIcon } from './NotificationIcon'
import styles from './NotificationItem.module.css'
import { SendingStatus } from 'modules/notifications/enums/SendingStatus'
import { EventType } from 'modules/notifications/enums/EventType'

dayjs.extend(relativeTime)

type NotificationItemProps = {
  title: string
  message: string
  date: Date | string
  eventType: EventType
  deliveryStatus: SendingStatus
  size?: 'small' | 'normal'
  onClick?: () => void
}

export const NotificationItem = ({
  title,
  message,
  date,
  eventType,
  deliveryStatus,
  size = 'normal',
  onClick,
}: NotificationItemProps) => {
  const isUnread = deliveryStatus === SendingStatus.Pending

  return (
    <Box
      onClick={onClick}
      className={`${styles.notificationContainer} ${
        size === 'small' ? styles.notificationSmall : styles.notificationNormal
      }`}
    >
      {isUnread && <Box className={styles.unreadIndicator} />}

      <Box className={styles.notificationIconContainer}>
        <NotificationIcon eventType={eventType} />
      </Box>

      <Box className={styles.contentContainer}>
        <Typography
          className={`${styles.notificationTitle} ${
            size === 'small' ? styles.notificationTitleSmall : styles.notificationTitleNormal
          } ${isUnread ? styles.unreadNotification : ''}`}
        >
          {title}
        </Typography>
        <Typography
          className={`${styles.notificationMessage} ${
            size === 'small' ? styles.notificationMessageSmall : styles.notificationMessageNormal
          }`}
        >
          {message}
        </Typography>
        <Typography className={styles.notificationDate}>
          {dayjs(date).locale('es').fromNow()}
        </Typography>
      </Box>
    </Box>
  )
}
